import { render, staticRenderFns } from "./newAbout.vue?vue&type=template&id=d139f068&scoped=true"
import script from "./newAbout.vue?vue&type=script&lang=js"
export * from "./newAbout.vue?vue&type=script&lang=js"
import style0 from "./newAbout.vue?vue&type=style&index=0&id=d139f068&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d139f068",
  null
  
)

export default component.exports